var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-0",attrs:{"id":"top"}},[_c('b-jumbotron',{staticClass:"jumbo mt-0",attrs:{"fluid":""}},[_c('h2',{staticClass:"text-light mb-2"},[_vm._v("Loblolly Software LLC")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }